import { defineStore } from 'pinia'
import { useProjectStore } from '@/store/projectStore'
import translation from '@/shared/utils/translation.js'

export const useLocaleStore = defineStore('localeStore', {
  state: () => ({
    locale: null,
  }),
  actions: {
    async setLocale(code = null) {
      const projectStore = useProjectStore()    
      const { VITE_DEFAULT_LOCALE: defaultLocale } = import.meta.env
      const { language } = projectStore?.project
      if (code) {
        this.locale = code
        // Actualizar traducciones del projectStore cuando cambie el idioma
        projectStore.updatePaymentInfoTranslations()
        return
      }
      if (language) {
        this.locale = translation.isLocaleSupported(language) ? language : defaultLocale
        await translation.switchLanguage(this.locale)
        // Actualizar traducciones del projectStore cuando se establezca el idioma inicial
        projectStore.updatePaymentInfoTranslations()
        return
      }
      this.locale = defaultLocale
      // Actualizar traducciones del projectStore cuando se use el idioma por defecto
      projectStore.updatePaymentInfoTranslations()
      return
    },
  },
})
